import { Component, input, signal } from '@angular/core';
import { NgxExtendedPdfViewerModule, pdfDefaultOptions } from 'ngx-extended-pdf-viewer';
import { ButtonModule } from '@openng/optimus-ui/button';
import { ProgressBar } from '@openng/optimus-ui/progressbar';
import { ProgressSpinner } from '@openng/optimus-ui/progressspinner';

pdfDefaultOptions.defaultCacheSize = 20;

@Component({
  selector: 'lib-pdf-viewer',
  standalone: true,
  imports: [NgxExtendedPdfViewerModule, ProgressBar, ProgressSpinner, ButtonModule],
  templateUrl: './pdf-viewer.component.html',
  styleUrl: './pdf-viewer.component.scss'
})
export class PdfViewerComponent {
  src = input.required<string>();
  height = input<string>('100%');

  progress = signal<number>(0);
  isLoaded = signal<boolean>(false);
  error = signal<string | null>(null);

  // Toggled off/on to force ngx-extended-pdf-viewer to re-fetch src() on retry.
  protected readonly showViewer = signal(true);

  onProgress(event: { percent: number }): void {
    this.progress.set(Math.round(event.percent));
  }

  onLoadError(): void {
    this.isLoaded.set(true);
    this.error.set('Failed to load PDF. Please try again.');
  }

  retry(): void {
    this.error.set(null);
    this.isLoaded.set(false);
    this.progress.set(0);
    this.showViewer.set(false);
    setTimeout(() => this.showViewer.set(true));
  }
}
